import { render, staticRenderFns } from "./Tractor.vue?vue&type=template&id=8e5e11b8"
import script from "./Tractor.vue?vue&type=script&lang=ts"
export * from "./Tractor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports